const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  PARTIAL_CONTENT: 206,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
};


export {
  HTTP_STATUS_CODES,
};
